import Module from '../utils/Module'
import {gsap} from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class ArticleModule extends Module {
  constructor (options) {
    super(options)

    this.DOMEl = options.element;
    this.articleTitle = this.DOMEl.querySelector(".article__header h1").innerText;
    this.undercontent = this.DOMEl.querySelector(".article__under-content");
    this.articlecontacts = this.DOMEl.querySelector('.article-contacts');
    this.articlesCards = this.DOMEl.querySelectorAll(".article-card");
    this.shareButtons = this.DOMEl.querySelectorAll(".share-buttons a");

    this.init()
  }

  init () {
    this.shareButtons.forEach(link => {
      link.addEventListener('click', () => {
        this.trackShareClick(link);
      });
    });

    this.articlesCards.forEach(card => {
      card.addEventListener('click', () => {
        this.trackArticleClick(card);
      });
    });

    ScrollTrigger.create({
      trigger: this.undercontent,
      start: "top center+=100",
      onEnter: ()=>{
        gsap.to(this.undercontent, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out"});
      },
      onEnterBack: ()=>{
        gsap.to(this.undercontent, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out"});
      }
    });
    ScrollTrigger.create({
      trigger: this.articlecontacts,
      start: "top center+=100",
      onEnter: ()=>{
        gsap.to(this.articlecontacts, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out"});
      },
      onEnterBack: ()=>{
        gsap.to(this.articlecontacts, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out"});
      }
    });
  }

  trackArticleClick(articleCard) {
    dataLayer.push({
      "event": "contentInteraction",
      "interaction": {
        "category": "news interaction",
        "action": articleCard.querySelector('.article-title').innerHTML.trim(),
        "label": window.location.href
      }
    });
  }

  trackShareClick(link) {
    dataLayer.push({
      "event": "contentInteraction",
      "interaction": {
        "category": "article sharing",
        "action": this.articleTitle,
        "label": link.dataset.socialMedia
      }
    });
  }

}
